import React, { FC, useMemo } from "react";
import { PictureOutlined, UserOutlined } from "@ant-design/icons";
import { MachineOverviewItem } from "shared/api";
import { BaseOverviewCard, AssignedItem } from "./BaseOverviewCard";

const MachineCard: FC<{ item: MachineOverviewItem }> = ({ item }) => {
  const {
    machine_name,
    machine_image,
    open_tasks,
    max_priority,
    max_days_overdue,
    tasks_by_user,
  } = item;

  const coverImage = machine_image || "";

  const assignedItems: AssignedItem[] = useMemo(() => {
    return Object.entries(tasks_by_user ?? {}).map(([name, count]) => ({
      name,
      count,
    }));
  }, [tasks_by_user]);

  return (
    <BaseOverviewCard
      title={machine_name}
      coverImage={coverImage}
      coverFallbackIcon={
        <PictureOutlined className="text-5xl text-neutral-300" />
      }
      openTasks={open_tasks}
      maxPriority={max_priority}
      maxDaysOverdue={max_days_overdue}
      assignedItems={assignedItems}
      assignedTitle="Assigned to"
      assignedEmptyText="No assigned users"
      assignedItemIcon={<UserOutlined className="shrink-0 text-neutral-400" />}
      filterKey="machine"
      filterValue={machine_name}
    />
  );
};

export { MachineCard };
